import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { nanoid } from 'nanoid';
import NavList from './NavList';
import { useStyles } from './style';

/**
 * @name PrimaryNav
 * @description Displays primary navgiation links of footer
 * @param {*} param0 - Destructured object
 * @param {object} param0.data - Footer navigation data from strapi
 * @returns {JSX.Element} ReactElement
 */
const PrimaryNav = ({ data }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Grid
      item
      container
      spacing={2}
      wrap='wrap'
      justifyContent='space-between'
      sx={styles.containerGrid}
    >
      {data?.map(nav => (
        <Grid key={nanoid(8)} item xs={12} md='auto' sx={styles.navGrid}>
          <NavList nav={nav} />
        </Grid>
      ))}
    </Grid>
  );
};

export default PrimaryNav;
